<template>
  <section id="benefitDetailsHeader" class="p-3" :style="headerStyle">
    <h1 class="ms-3">
      {{ benefit.thumbnailTitle }}
    </h1>
  </section>
  <div class="w-100 px-3 mt-3">
    <section class="px-3 d-flex gap-3 flex-column justify-content-between">
      <div v-for="item in benefit?.descriptionItems" v-bind:key="item.itemId">
        <div class="row">
          <div class="col item-icon">
            <span class="material-symbols-outlined"> {{ item.icon }} </span>
          </div>
          <div class="col">
            <h2>{{ item.subTitle }}</h2>
            <p v-html="item.description"></p>
          </div>
        </div>
      </div>
      <div id="venue-sub" v-if="benefit?.validAt">
        <span class="w-100">{{ benefit.validAt.subTitle }}:</span>
        <img class="w-100" :src="getVenuesImg(1)" alt="venues_1" />
        <img class="w-100" :src="getVenuesImg(2)" alt="venues_2" />
      </div>
      <a
        :href="benefit?.termsAndConditionsUrl"
        class="pj-link-green text-decoration-underline fw-bold"
        >{{ t("TERMS_AND_CONDITIONS") }}</a
      >
    </section>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, onMounted, PropType } from "vue";
import { MasterCardBenefit } from "@/apps/credit-line/types/responses";
import { useI18n } from "@/apps/credit-line/composables/useI18n";
import useAsset from "@/apps/credit-line/helpers/useAsset";
import logAnalyticsEvent from "@/apps/credit-line/services/google-analytics-events.service";
import AnalyticEvents from "@/shared-helpers/google-analytics-events.helper";

export default defineComponent({
  name: "BenefitDetails",
  props: {
    benefit: Object as PropType<MasterCardBenefit>,
  },
  setup(props) {
    const { t } = useI18n();
    const headerStyle = computed(() => ({
      backgroundImage: `url(${useAsset(
        `img/credit-line/${props.benefit?.id}_banner.webp`
      )}), url(${useAsset(`img/credit-line/benefit_banner.png`)})`,
      backgroundSize: "cover",
    }));
    const getVenuesImg = (val: number): string => {
      return useAsset(`img/credit-line/mc_venue${val}.png`);
    };

    onMounted(() => {
      logAnalyticsEvent(
        AnalyticEvents.CreditLine.PageViewPCBenefitDetails,
        "PC_Benefits",
        props.benefit?.id
      );
    });

    return { t, headerStyle, getVenuesImg };
  },
});
</script>

<style lang="scss" scoped>
#benefitDetailsHeader {
  width: 100%;
  height: 7.875rem;

  & h1 {
    margin-top: 15%;
    color: white;
    font-feature-settings: "clig" off, "liga" off;
    font-family: Inter;
    font-size: 1.0625rem;
    font-style: normal;
    font-weight: 700;
    line-height: 1.5rem; /* 141.176% */
  }
}

#venue-sub {
  color: var(--text-grey-dark, #666);
  font-feature-settings: "clig" off, "liga" off;
  font-family: Nunito;
  font-size: 0.8125rem;
  font-style: normal;
  font-weight: 600;
  line-height: 160%; /* 1.3rem */
}

button {
  width: 90%;
  margin: 0 auto;
  bottom: 1rem;
}

.item-icon {
  display: flex;
  max-height: 3rem;
  max-width: 3rem;
  padding: 0.75rem 0.625rem;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 6.25rem;
  background: var(--background-500, #f2f2f2);
}

h2 {
  color: black;
  font-feature-settings: "clig" off, "liga" off;
  font-family: Nunito;
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 600;
  line-height: 144%; /* 1.26rem */
}
</style>
